import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { customMultiValue, customOption } from "../../../constants/const";
import { ApiFinance } from "../ApiFinance";
import { GetLanguageString } from "../../helper/Components";
import FundFilter from "../../helper/SearchFilter/FundFilter";

const STATUS_KEYS = [
  "held",
  "in_remittance",
  "posting",
  "posted",
  "voided",
];

const ManageUsraInfaqFilters = ({ values, setValues }) => {
  const { t } = useTranslation();
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [loadingHeads, setLoadingHeads] = useState(false);

  const statusOptions = STATUS_KEYS.map((value) => ({
    value,
    label: t(`usra_infaq_status_${value}`),
  }));

  useEffect(() => {
    setLoadingHeads(true);
    ApiFinance()
      .GetFinanceSubCategoryAccountsByCode("infaq")
      .then((res) => {
        const list = (res.data || []).map((item) => ({
          value: String(item.value),
          label: item.label,
        }));
        setInfaqHeads(list);
      })
      .catch(() => setInfaqHeads([]))
      .finally(() => setLoadingHeads(false));
  }, []);

  return (
    <>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label" style={{ fontWeight: 600, color: "#2f4050" }}>
              <GetLanguageString props="fund_account_head" />
            </Label>
            <Select
              components={{ Option: customOption, MultiValue: customMultiValue }}
              options={infaqHeads}
              value={values.selectedAccounts}
              isMulti
              isLoading={loadingHeads}
              className="basic-multi-select no-drag"
              classNamePrefix="select"
              placeholder={t("member_select")}
              onChange={(val) =>
                setValues((prev) => ({ ...prev, selectedAccounts: val || [] }))
              }
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label" style={{ fontWeight: 600, color: "#2f4050" }}>
              <GetLanguageString props="usra_infaq_status" />
            </Label>
            <Select
              options={statusOptions}
              value={values.selectedStatuses}
              isMulti
              className="basic-multi-select no-drag"
              classNamePrefix="select"
              placeholder={t("member_select")}
              onChange={(val) =>
                setValues((prev) => ({ ...prev, selectedStatuses: val || [] }))
              }
            />
          </FormGroup>
        </Col>
      </Row>
      <FundFilter values={values} setValues={setValues} showFullDate />
    </>
  );
};

export default ManageUsraInfaqFilters;
